import React, { useEffect, useRef, useState } from "react";
import banner from "assets/img/profile/banner.png";
import Card from "components/card";
import { useSelector } from "react-redux";
import { currentUser } from "services/users/authSlice";
import avatar from "assets/img/avatars/avatar4.png";
import ApiList from "services/apiList";
import { ESService } from "services/esService";

const Banner = () => {
  const user = useSelector(currentUser);

  const [data, setData] = useState([]);
  const mount = useRef(true);

  useEffect(() => {
    if (mount.current) {
      mount.current = false;
      const token = user.token;
      const es = new ESService(token);
      es.get(ApiList.countsUrl).then((json) => {
        if (json["status"]) {
          setData(json["data"]);
        }
      });
    }
  }, [user]);

  return (
    <Card extra={"items-center w-full h-full p-[16px] bg-cover"}>
      {/* Background and profile */}
      <div
        className="relative mt-1 flex h-32 w-full justify-center rounded-xl bg-cover"
        style={{ backgroundImage: `url(${banner})` }}
      >
        <div className="absolute -bottom-12 flex h-[87px] w-[87px] items-center justify-center rounded-full border-[4px] border-white bg-pink-400 dark:!border-navy-700">
          <img
            className="h-full w-full rounded-full"
            src={
              user === null || user === undefined
                ? avatar
                : user.profile === "" ||
                  user.profile === null ||
                  user.profile === undefined
                ? avatar
                : ApiList.baseMediaUrl + user.profile
            }
            alt=""
          />
        </div>
      </div>

      {/* Name and position */}
      <div className="mt-16 flex flex-col items-center">
        <h4 className="text-xl font-bold text-navy-700 dark:text-white">
          {user.lastname === null || user.lastname === undefined
            ? " "
            : user.lastname}{" "}
          {user.firstname === null || user.firstname === undefined
            ? "Хэрэглэгч"
            : user.firstname}
        </h4>
       
      </div>
      {/* Post followers */}
      <div className="mt-6 mb-3 flex gap-4 md:!gap-14">
        <div className="flex flex-col items-center justify-center">
          <p className="text-2xl font-bold text-navy-700 dark:text-white">{data['schedule_count']}</p>
          <p className="text-sm font-normal text-gray-600">Хичээлийн цаг</p>
        </div>
        <div className="flex flex-col items-center justify-center">
        
        <p className="text-2xl font-bold text-navy-700 dark:text-white">{data['lesson_count']}</p>
          <p className="text-sm font-normal text-gray-600">Заадаг хичээл</p>
        </div>
        <div className="flex flex-col items-center justify-center">
          
        <p className="text-2xl font-bold text-navy-700 dark:text-white">{data['course_count']}</p>
          <p className="text-sm font-normal text-gray-600">Хичээл заадаг анги</p>
        </div>
      </div>
    </Card>
  );
};

export default Banner;
